export const languages = [
  { label: "english", value: "en" },
  { label: "german", value: "de" },
  { label: "french", value: "fr" },
  { label: "italian", value: "it" },
];

export const getLanguageLabel = (value: string): string =>
  languages.find((l) => l.value === value)?.label || "";

export const getLanguageValue = (label: string): string =>
  languages.find((l) => l.label === label)?.value || "";
